<template>
  <b-badge pill variant="warning" v-if="count>0">{{ count }}</b-badge>
</template>

<script>
import {Discussion} from "../js/caller";

export default {
  name   : "NotifMessage",
  props  : {
    discussions: String
  },
  data   : function() {
    return {
      discussions_id: [],
      count         : 0,
      timeOutID     : 0,
    }
  },
  methods: {
    getNewMessageCount(id) {
      if (!id) return;
      return Discussion.GetMessages(
          id, {
            count : true,
            status: Discussion.MessageStatus.Unseen,
          });
    },
    getAllNewMessageCount() {
      if (!this.discussions_id.length) return;
      Promise
          .all(this.discussions_id.map(id => this.getNewMessageCount(id)))
          .then(res => {
            this.count = res.reduce((p, r) => p + r.count, 0)
          });
    },
    getDiscussionID() {
      return Discussion.GetDiscussions().then((res) => {
        this.discussions_id = res.map(r => r.id);
      })
    }
  },
  async created() {
    Discussion.Register(Discussion.Events.UPDATE_STATUS, () => this.getAllNewMessageCount());
  },
  async mounted() {
    if (!this.discussions) {
      await this.getDiscussionID();
    } else {
      this.discussions_id = [this.discussions];
    }
    this.getAllNewMessageCount();
    this.timeOutID = setInterval(this.getAllNewMessageCount.bind(this), 60000);
  },
  beforeDestroy() {
    clearInterval(this.timeOutID)
  }
}
</script>

<style scoped>
.badge {
  position: absolute;
  top: 0;
  left: calc(100% - 1rem);
}
</style>